/* FrostStrip theme scripts */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    format = format || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = match ? match[1] : 'amount';
    function fmt(n, decimals, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (n / 100).toFixed(decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var value;
    switch (type) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Quantity steppers (product + cart) ---------- */
  function initQty(scope) {
    scope.querySelectorAll('.qty').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var min = parseInt(input.min || '1', 10);
      function set(v) {
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || min) - 1); });
      if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || 0) + 1); });
      if (input.hasAttribute('data-auto-submit')) {
        var timer;
        input.addEventListener('change', function () {
          clearTimeout(timer);
          timer = setTimeout(function () { if (input.form) input.form.submit(); }, 600);
        });
      }
    });
  }

  /* ---------- Product section ---------- */
  function initProduct(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var dataEl = root.querySelector('[data-product-json]');
    var data = { variants: [], moneyFormat: '${{amount}}' };
    try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) {}

    // Gallery
    var slides = Array.prototype.slice.call(root.querySelectorAll('.gallery__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));

    function show(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var active = n === index;
        s.classList.toggle('is-active', active);
        if (!active) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
      var t = thumbs[index];
      if (t && t.parentElement) {
        var p = t.parentElement;
        var left = t.offsetLeft - p.offsetLeft - (p.clientWidth - t.clientWidth) / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    function showMedia(id) {
      var i = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(id); });
      if (i > -1) show(i);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.thumb, 10)); });
    });
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    var main = root.querySelector('.gallery__main');
    if (main) {
      var startX = null;
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        startX = null;
      });
    }

    // Zoom / lightbox
    var zoom = root.querySelector('[data-zoom]');
    if (zoom) {
      zoom.addEventListener('click', function () {
        var img = slides[index] && slides[index].querySelector('img');
        if (!img) return;
        var box = document.createElement('div');
        box.className = 'lightbox';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        var big = document.createElement('img');
        big.src = img.currentSrc || img.src;
        big.alt = img.alt || '';
        var close = document.createElement('button');
        close.className = 'circle-btn';
        close.setAttribute('aria-label', 'Close');
        close.innerHTML = '&times;';
        box.appendChild(big);
        box.appendChild(close);
        function remove() { box.remove(); document.removeEventListener('keydown', onKey); }
        function onKey(e) { if (e.key === 'Escape') remove(); }
        box.addEventListener('click', remove);
        document.addEventListener('keydown', onKey);
        document.body.appendChild(box);
        close.focus();
      });
    }

    // Variants
    var buy = root.querySelector('[data-buy]');
    var select = root.querySelector('[data-variant-select]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price-current]');
    var compareEl = root.querySelector('[data-price-compare]');
    var saveEl = root.querySelector('[data-price-save]');
    var availEl = root.querySelector('[data-availability]');
    var availText = root.querySelector('[data-availability-text]');
    var addBtn = root.querySelector('[data-add-btn]');
    var addText = root.querySelector('[data-add-text]');
    var texts = buy ? buy.dataset : {};

    function updateVariant(variant) {
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = texts.textUnavailable || 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, data.moneyFormat);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price, data.moneyFormat);
      }
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) {
          var pct = Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          saveEl.textContent = (saveEl.dataset.label || 'Save [percent]%').replace('[percent]', pct);
        }
      }
      if (availEl) availEl.classList.toggle('is-soldout', !variant.available);
      if (availText) availText.textContent = variant.available ? (texts.textAvailable || '') : (texts.textSoldout || 'Sold out');
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? (texts.textAdd || 'Add to Cart') : (texts.textSoldout || 'Sold out');
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (root.dataset.productUrl && window.history && history.replaceState) {
        history.replaceState({}, '', root.dataset.productUrl + '?variant=' + variant.id);
      }
    }

    if (select) {
      select.addEventListener('change', function () {
        var v = data.variants.find(function (x) { return String(x.id) === select.value; });
        updateVariant(v);
      });
    }

    // Add to cart via AJAX so errors are shown right under the button
    var form = root.querySelector('form.product-form');
    var errEl = root.querySelector('[data-form-error]');
    function showError(msg) {
      if (!errEl) { alert(msg); return; }
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    if (form && buy && window.fetch) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.name && e.submitter.name !== 'add') return;
        e.preventDefault();
        if (errEl) errEl.hidden = true;
        var idField = form.querySelector('[name="id"]');
        if (!idField || !idField.value) { showError('No product variant selected. Assign a real product to this page.'); return; }
        if (addBtn) addBtn.classList.add('is-loading');
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var qtyField = form.querySelector('[name="quantity"]');
        var payload = { items: [{ id: Number(idField.value), quantity: Math.max(1, parseInt(qtyField ? qtyField.value : 1, 10) || 1) }] };
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
            if (buy.dataset.afterAdd === 'checkout') { window.location.href = base + 'checkout'; return null; }
            if (buy.dataset.afterAdd !== 'stay') {
              window.location.href = buy.dataset.cartUrl || (base + 'cart');
              return null;
            }
            return fetch(base + 'cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            if (!cart) return;
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            if (addText) {
              var original = addText.textContent;
              addText.textContent = '\u2713';
              setTimeout(function () { addText.textContent = original; }, 1600);
            }
          })
          .catch(function (err) { showError(err.message); })
          .finally(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
      });
    }

    initQty(root);
  }


  /* ---------- "Order Now" buttons (landing page) ---------- */
  function initOrderForms(scope) {
    scope.querySelectorAll('[data-order-form]').forEach(function (form) {
      if (form.dataset.bound || !window.fetch) return;
      form.dataset.bound = '1';
      var btn = form.querySelector('[data-order-btn]');
      var text = form.querySelector('[data-order-text]');
      var errEl = form.querySelector('[data-form-error]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errEl) errEl.hidden = true;
        if (btn) btn.classList.add('is-loading');
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var id = Number(form.querySelector('[name="id"]').value);
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
            var after = form.dataset.afterAdd;
            if (after === 'checkout') { window.location.href = base + 'checkout'; return null; }
            if (after !== 'stay') { window.location.href = form.dataset.cartUrl || (base + 'cart'); return null; }
            return fetch(base + 'cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            if (!cart) return;
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            if (text) {
              var original = text.textContent;
              text.textContent = '\u2713';
              setTimeout(function () { text.textContent = original; }, 1600);
            }
          })
          .catch(function (err) {
            if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } else { alert(err.message); }
          })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initHeader(scope) {
    scope.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var nav = document.getElementById(btn.getAttribute('aria-controls'));
        if (!nav) return;
        var open = nav.hasAttribute('hidden');
        if (open) nav.removeAttribute('hidden'); else nav.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-product-section]').forEach(initProduct);
    initHeader(scope);
    initOrderForms(scope);
    initQty(scope);
    var header = document.querySelector('.site-header--sticky');
    if (header) document.documentElement.style.setProperty('--header-offset', header.offsetHeight + 'px');
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
